import { Router } from 'vue-router'

import { Team, TeamInfo } from '@/services/team'
import { DashboardService } from '../../../../dashboard.service'
import { Inject, Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { routerInjectToken } from '@/common/const/inject-tokens'
import { ServicePermissionService } from '@/services/service-permission.service'

export const ACTIVE_NAME_MAP = {
  default: '',
  viewTeam: 'view-team',
  leaveTeam: 'leaveTeam'
}

export interface LeaveParams {
  team_id: number
  target_uid: string
}

@Injectable()
export class TeamManageService {
  constructor (private http: Http,
               private team: Team,
               private servicePermission: ServicePermissionService,
               private dashboardService: DashboardService,
               @Inject(routerInjectToken)
               private router: Router) {
  }

  async doSwitchTeam (options: TeamInfo) {
    await this.team.updateCurrentTeam(options)
    await this.servicePermission.refreshCurrentTeamPermission()
    return this.dashboardService.reload()
  }

  doLeaveTeam (options: LeaveParams) {
    return this.http.post('/team/exit', options).then(response => {
      this.team.updateCurrentTeam(null)
      this.router.push('/team')

      return response
    })
  }

  getTeamList () {
    return this.team.refreshTeamList()
  }
}
